export function isTransparent(color: string | undefined): boolean {
  if (!color) return true;
  // hex8 ending in 00?
  if (color.startsWith('#') && color.length === 9) {
    return color.slice(-2).toLowerCase() === '00';
  }
  // rgba(… ,0)
  return false;
}
